'use client'

import { useCMSMenu } from '@/src/domains/cms-menus/hooks/useCMSMenu'
import { getHeaderSubmenu } from '@/src/domains/header/components/Header/Header.utils'

export const useHeaderClinicSubmenus = () => {
  const { data } = useCMSMenu('clinic-menu')

  return data.map(getHeaderSubmenu)
}
